
export const suppressionListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLSUPPRESSIONLISTING_REQUEST: 'GETALLSUPPRESSIONLISTING_REQUEST',
    GETALLSUPPRESSIONLISTING_REQUEST_END: 'GETALLSUPPRESSIONLISTING_REQUEST_END',
    GETALLSUPPRESSIONLISTING_SUCCESS: 'GETALLSUPPRESSIONLISTING_SUCCESS',
    GETALLSUPPRESSIONLISTING_FAILURE: 'GETALLSUPPRESSIONLISTING_FAILURE'
};

